import React from 'react';
import Icon from '../components/Icon';

const UserLocator = ({getShopsAtUserPosition, isLocating}) => (
  <label className={`user-locator input-group-text ${isLocating ? 'is-locating' : ''}`} onClick={() => getShopsAtUserPosition()}>
    <Icon icon='screenshot' />
    <span className="spinner"></span>
  </label>
);

export default UserLocator;
